import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import Logo from './Logo';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    // If not on home page, navigate to home first
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="header header-gradient-bg">
      <nav className="header-nav">
        <div className="header-content">
          <div>
            <motion.div
              className="header-logo"
            >
              <Logo width={140} height={32} />
            </motion.div>
          </div>
          
          {/* Desktop Navigation */}
          <div className="header-nav-desktop">
            <button
              onClick={() => scrollToSection('about')}
              className="header-nav-link"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('expertise')}
              className="header-nav-link"
            >
              Expertise
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className="header-nav-link"
            >
              Projects
            </button>
            <button
              onClick={() => scrollToSection('design')}
              className="header-nav-link"
            >
              Design
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="header-nav-link"
            >
              Contact
            </button>
          </div>

          <div className="header-cta-section">
            <div className="header-cta-desktop">
              <motion.button
                onClick={() => scrollToSection('contact')}
                className="header-cta-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Get Started
              </motion.button>
            </div>
            
            {/* Mobile menu button */}
            <motion.button
              className="mobile-menu-btn"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <div className="mobile-menu-icon">
                <motion.div 
                  className={`mobile-menu-line ${isMenuOpen ? 'open-1' : ''}`}
                  animate={isMenuOpen ? { rotate: 45, y: 6 } : { rotate: 0, y: 0 }}
                />
                <motion.div 
                  className={`mobile-menu-line ${isMenuOpen ? 'open-2' : ''}`}
                  animate={isMenuOpen ? { opacity: 0 } : { opacity: 1 }}
                />
                <motion.div 
                  className={`mobile-menu-line ${isMenuOpen ? 'open-3' : ''}`}
                  animate={isMenuOpen ? { rotate: -45, y: -6 } : { rotate: 0, y: 0 }}
                />
              </div>
            </motion.button>
          </div>
        </div>

        {/* Mobile menu */}
        <motion.div
          className={`mobile-menu ${isMenuOpen ? '' : 'hidden'}`}
          initial={{ opacity: 0, height: 0 }}
          animate={isMenuOpen ? { opacity: 1, height: 'auto' } : { opacity: 0, height: 0 }}
        >
          <div className="mobile-menu-content">
            <button
              onClick={() => scrollToSection('about')}
              className="mobile-menu-link"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('expertise')}
              className="mobile-menu-link"
            >
              Expertise
            </button>
            <button
              onClick={() => scrollToSection('projects')}
              className="mobile-menu-link"
            >
              Projects
            </button>
            <button
              onClick={() => scrollToSection('design')}
              className="mobile-menu-link"
            >
              Design
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="mobile-menu-link"
            >
              Contact
            </button>
            <motion.button
              onClick={() => scrollToSection('contact')}
              className="mobile-menu-cta"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Get Started
            </motion.button>
          </div>
        </motion.div>
      </nav>
    </header>
  );
};

export default Header;